export function removeNullParams(params) {
  return Object.fromEntries(
    Object.entries(params).filter(([, value]) => !!value || value === 0)
  );
}
